import { notify } from "@kyvg/vue3-notification";


export const SuccessAllert = (message: string) => {
       notify({
              title: "Successfull ",
              text: message,
              type: 'success',
       });
       location.reload()
}

export const SuccessAllertWithoutReload = (message: string) => {
       notify({
              title: "Successfull ",
              text: message,
              type: 'success',
       });
}

export const InfoAlert = (message: string) => {
       notify({
              title: "Information ",
              text: message,
              type: 'info',
              group: 'error',
              
       });
}

export const ErrorAlert = (error: any) => {
       if (typeof error == 'object') {
              
              notify({
                     title: error.response?._data?.error?.name||"local error",
                     text: error.response?._data?.error?.message || error.message,
                     type: 'error',
                     group: 'error',
                     duration: 20000

              });


       } else {
              notify({
                     title: 'Unknow Error',
                     text: 'Please refresh your page and continiue',
                     type: 'error',
                     group: 'error',
                     duration: 10000

              }); 
       }
       // Ensure FetchErrorHandle is defined or imported
       FetchErrorHandle(error);

}